import React from 'react'
import Card from '../../components/Card'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800">Quem Somos</h1>

				<p>A ZelAI é uma empresa especializada em soluções digitais, que nasceu com o propósito de transformar a forma como pessoas e negócios se relacionam com a tecnologia.</p>

				<p className="font-bold mt-4">Nossa missão</p>
				<p>Oferecer soluções digitais inovadoras, acessíveis e seguras que contribuam para o crescimento sustentável dos nossos clientes, promovendo eficiência, competitividade e transformação digital.</p>

				<p className="font-bold mt-4">Nossa visão</p>
				<p>Ser referência no mercado nacional e internacional em tecnologia e inovação, reconhecida pela excelência técnica, ética profissional e impacto positivo nos negócios e na sociedade.</p>

				<p className="font-bold mt-4">Nossos valores</p>
				<p>Na ZelAI, acreditamos em:</p>
				<p>• Ética e integridade em todas as relações;</p>
				<p>• Comprometimento com resultados e excelência;</p>
				<p>• Respeito à privacidade e à proteção de dados;</p>
				<p>• Inovação constante e foco no futuro;</p>
				<p>• Colaboração, diversidade e inclusão;</p>
				<p>• Responsabilidade social e ambiental.</p>

				<p className="font-bold mt-4">Nossa equipe</p>
				<p>Contamos com um time multidisciplinar, apaixonado por tecnologia e movido por desafios. Profissionais experientes em desenvolvimento de software, segurança da informação, design de experiência, automação, inteligência artificial e gestão de projetos compõem a base da nossa entrega de valor.</p>

				<p className="font-bold mt-4">Nosso compromisso com a LGPD</p>
				<p>Levamos a privacidade a sério. Todas as nossas soluções são desenvolvidas de acordo com os princípios da Lei Geral de Proteção de Dados Pessoais (LGPD), garantindo transparência, segurança e respeito aos direitos dos titulares de dados.</p>

				<p className="font-bold mt-4">Fale com a gente</p>
				<p>Quer saber mais sobre a ZelAI? Estamos prontos para ajudá-lo(a) a evoluir digitalmente com segurança e inteligência.</p>

				<p className="mt-8">E-mail: <a href="mailto:contato@zelai.com.br">contato@zelai.com.br</a></p>

			</Card>
		</div>
	)
}
